import { Icon, type IconName } from "@-/dev.improve.haniverse.components.ui.icon";
import type { ColorValue } from "@-/com.npmjs.react-native";

// The route names here are the path segments relative to the browse index (see
// `path.relative(index, tab.route)` in browse-layout). Keep the keys in sync with the tab routes.
const browseLayoutTabIconDict: Record<string, IconName> = {
  characters: "HanziZi",
  levels: "LuListOrdered",
  primitives: "IoExtensionPuzzle",
  words: "HiChatBubbleLeftRight",
};

export function browseLayoutTabBarIcon(screenName: string) {
  return function BrowseLayoutTabBarIcon({
    color,
    focused: _focused,
  }: {
    color: ColorValue;
    focused: boolean;
  }) {
    return (
      <Icon color={color} name={browseLayoutTabIconDict[screenName] ?? "LuHelpCircle"} size={25} />
    );
  };
}
